import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { useState } from "react";
import "./Prizes.css";

export default function Prizes() {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button className="prizes-btn" variant="text" onClick={handleClickOpen}>
        <p className="prizes-btn-text">בפרסים שווים!</p>
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          classes: { root: "prizes-container" },
        }}
      >
        <img
          className="prizes"
          src={process.env.PUBLIC_URL + "Assets/prizes.png"}
          alt="prizes"
        ></img>
        <div className="prizes-exit-btn">
          <Button variant="text" sx={{minWidth:'unset', padding:0}} onClick={handleClose}>

            <img
              className="x"
              src={process.env.PUBLIC_URL + "Assets/x.png"}
              alt="x"
            ></img>
          </Button>
        </div>
      </Dialog>
    </>
  );
}
